<div class="py-4 py-lg-5">
   <header
      class="container d-flex justify-content-between align-items-center flex-wrap mb-3 mb-lg-4"
   >
      <div class="d-flex justify-content-start align-items-center gap-3">
         <h1 class="main-heading mb-0">IPO Calendar</h1>
         <!-- <button *ngIf="selectedCountry" type="button"
        class="btn border d-flex align-items-center shadow-none gap-1 gap-lg-2 rounded-pill country-filter-btn"
        (click)="openCountriesPopup()">
        <img [src]="selectedCountry ? '/assets/flags/1x1/' + selectedCountry.toLowerCase() + '.svg' : ''" alt=""
          class="bg-light border rounded-circle" width="20px" height="20px" />
        <span class="fw-500">{{ selectedCountry }}</span>
        <svg height="10px" width="10px" class="chevron-svg flex-shrink-0" viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor"
            d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
        </svg>
      </button> -->
         <div class="country-selector" [class.open]="showDropdown">
            <div class="selected-option" (click)="toggleDropdown()">
               <img
                  [src]="
                     '/assets/flags/1x1/' +
                     selectedCountry.toLowerCase() +
                     '.svg'
                  "
                  alt=""
                  class="country-flag"
                  width="20"
                  height="20"
               />
               <span class="country-name">{{
                  getCountryName(selectedCountry)
               }}</span>
               <svg
                  class="dropdown-icon"
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
               >
                  <path
                     d="M1 1L5 5L9 1"
                     stroke="currentColor"
                     stroke-width="1.5"
                     stroke-linecap="round"
                  />
               </svg>
            </div>

            <div class="dropdown-options" *ngIf="showDropdown">
               <div class="option" (click)="selectCountry('US')">
                  <img
                     src="/assets/flags/1x1/us.svg"
                     alt=""
                     class="country-flag"
                     width="20"
                     height="20"
                  />
                  <span>USA</span>
               </div>
               <div class="option" (click)="selectCountry('IN')">
                  <img
                     src="/assets/flags/1x1/in.svg"
                     alt=""
                     class="country-flag"
                     width="20"
                     height="20"
                  />
                  <span>India</span>
               </div>
            </div>
         </div>
      </div>
   </header>
   <div class="container mb-4">
      <article class="disclaimer-card">
         <h6 class="fw-600">Disclaimer</h6>
         <p class="mb-0">
            {{ disclaimer }}
         </p>
      </article>
   </div>

   <div class="ipo-status-tabs container mb-4">
      <button
         class="ipo-tab-btn"
         [class.ipo-tab-active]="selectedTab === 'Upcoming'"
         (click)="selectTab('Upcoming')"
      >
         Upcoming
      </button>
      <button
         class="ipo-tab-btn"
         [class.ipo-tab-active]="selectedTab === 'Priced'"
         (click)="selectTab('Priced')"
      >
         Priced
      </button>
      <button
         class="ipo-tab-btn"
         [class.ipo-tab-active]="selectedTab === 'Withdrawn'"
         (click)="selectTab('Withdrawn')"
      >
         Withdrawn
      </button>
   </div>

   <div
      class="dropdown-container container d-flex align-items-center mb-3 mb-lg-4"
   >
      <div
         class="filter-select-wrapper"
         *ngFor="let dropdown of dropdownConfigs"
         style="border: none"
      >
         <label
            style="
               font-weight: 400;
               display: flex;
               margin-bottom: 4px;
               gap: 5px;
               font-size: 14px;
            "
         >
            {{ dropdown.label }}
            <img
               *ngIf="!isLoggedIn"
               src="/assets/images/role-icons/gold-crown.svg"
               class="yellow_gradient_word"
               ngbTooltip="Available in Starter Plan"
            />
         </label>

         <ng-select
            [items]="dropdown.options"
            style="max-width: 350px"
            bindLabel="label"
            bindValue="value"
            [multiple]="true"
            [closeOnSelect]="false"
            [hideSelected]="false"
            [placeholder]="dropdown.placeholder"
            [(ngModel)]="ngModelBindings[dropdown.id]"
            (ngModelChange)="onFilterChange(dropdown.label, $event)"
         >
            <ng-template ng-option-tmp let-item="item" let-index="index">
               <span
                  *ngIf="item.value === 'unlock'"
                  class="unlock-icon"
                  style="color: #009000"
               >
                  <i class="icon-lock"></i>
               </span>
               <span [style.color]="item.value === 'unlock' ? '#009000' : ''">
                  {{ item.label }}
               </span>
            </ng-template>
         </ng-select>
      </div>

      <div
         class="filter-select-wrapper position-relative"
         [ngClass]="{ open: isMonthYearDropdownOpen }"
         (clickOutside)="isMonthYearDropdownOpen = false"
         *ngIf="selectedTab === 'Priced'"
      >
         <!-- Main trigger -->
         <label
            style="
               font-weight: 400;
               display: flex;
               margin-bottom: 4px;
               gap: 5px;
               font-size: 14px;
            "
         >
            Select Month & Year
         </label>
         <div
            class="ng-select custom-month-year-trigger"
            (click)="toggleMonthYearDropdown($event); markTouched()"
            [ngClass]="{
               'ng-touched': isTouched,
               'ng-valid': isValid
            }"
         >
            <!-- Display selected tags -->
            <div class="selected-tags" *ngIf="selectedMonth || selectedYear">
               <ng-container *ngIf="selectedMonth">
                  <span class="tag">
                     <span
                        class="ng-value-icon left"
                        style="
                           padding-right: 5px;
                           border-right: 1px solid #b8dbff;
                        "
                        (click)="clearSelection('month', $event)"
                        >×</span
                     >
                     <span class="ng-value-label" style="padding-left: 5px">{{
                        selectedMonth
                     }}</span>
                  </span>
               </ng-container>
               <ng-container *ngIf="selectedYear !== null">
                  <span class="tag">
                     <span
                        class="ng-value-icon left"
                        style="
                           padding-right: 5px;
                           border-right: 1px solid #b8dbff;
                        "
                        (click)="clearSelection('year', $event)"
                        >×</span
                     >
                     <span class="ng-value-label" style="padding-left: 5px">{{
                        selectedYear
                     }}</span>
                  </span>
               </ng-container>
            </div>

            <!-- Placeholder if nothing selected -->
            <div class="ng-placeholder" *ngIf="!selectedMonth && !selectedYear">
               -Select-
            </div>

            <!-- Arrow -->
            <div class="ng-arrow-wrapper">
               <span class="ng-arrow">&#9662;</span>
            </div>
         </div>

         <!-- Dropdown content -->
         <div class="month-year-dropdown" *ngIf="isMonthYearDropdownOpen">
            <!-- Month Dropdown -->
            <select
               [(ngModel)]="selectedMonth"
               class="form-select month-dropdown"
               (change)="onMonthYearChange()"
            >
               <option value="" disabled [selected]="!selectedMonth">
                  Select a Month
               </option>
               <option
                  *ngFor="let month of allMonths"
                  [value]="month"
                  [selected]="month === selectedMonth"
               >
                  {{ month }}
               </option>
            </select>

            <!-- Year Dropdown -->
            <select
               [(ngModel)]="selectedYear"
               class="form-select year-dropdown"
               (change)="onMonthYearChange()"
            >
               <option [ngValue]="null" disabled>Select a Year</option>
               <option *ngFor="let year of getYearRange()" [ngValue]="year">
                  {{ year }}
               </option>
            </select>
         </div>
      </div>
   </div>

   <div class="container">
      <div class="min-width-zero">
         <app-dynamic-table
            [showCompliance]="true"
            [showComplianceRanking]="false"
            [columns]="tableColumns"
            [data]="data"
            [page]="page"
            [dataCount]="dataCount"
            [isDataLoading]="loading"
            [showResetButton]="true"
            [isSortingEnabled]="true"
            [sortColumn]="usdMarketCap"
            [sortOrder]="desc"
            [type]="dataType"
            [activeFiltersCount]="activeFiltersCount"
            (resetAllClicked)="handleResetAll()"
         >
         </app-dynamic-table>
      </div>
   </div>
</div>
